import { Menu } from "@mui/icons-material";
import { AppBar, Grid, IconButton } from "@mui/material";
import CustomText from "components/typography/CustomText";
import { DEFAULT_DRAWER_WIDTH } from "lib/global";
import { getLabel } from "models/third/freightways";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { openLoading } from "store/reducers/tools";
import BreadCrumb from "./BreadCrumb";
export default function MainHeader({ breadCrumb = [], onToggle = () => {} }) {
  const pathname = window.location.pathname;
  const orderInfo = useSelector((state) => state?.app?.orderInfo ?? {});
  const [file, setFile] = useState("");

  const handleClickConsignment = async (row) => {
    try {
      openLoading(true);
      const fileURL = await getLabel({
        tracking_info: orderInfo?.tracking_info ?? {},
        postCode: orderInfo?.address?.postcode ?? ""
      });
      setFile(fileURL);
    } catch (error) {
      console.log(error);
      openLoading(false);
    }
  };

  useEffect(() => {
    if (file) {
      setTimeout(() => {
        window.frames["printf"].focus();
        window.frames["printf"].print();
        openLoading(false);
      }, 1000);
    }
    // eslint-disable-next-line
  }, [file]);

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { md: `calc(100% - ${DEFAULT_DRAWER_WIDTH + 96}px)` },
        ml: { md: `${DEFAULT_DRAWER_WIDTH + 48}px` },
        marginRight: "48px",
      }}
      className={`h-18 overflow-hidden px-4 ${
        pathname === "/bake-dates"
          ? "bg-primary"
          : pathname === "/weekly-slots"
          ? "bg-warning"
          : "bg-white"
      }`}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="stretch"
        className="h-full"
      >
        <Grid item flexGrow={1}>
          <Grid container alignItems="stretch" className="h-full">
            {/* menu Icon */}
            <Grid item className="flex items-center mx-2 md:hidden">
              <IconButton
                color="secondary"
                aria-label="open drawer"
                edge="start"
                onClick={onToggle}
              >
                <Menu />
              </IconButton>
            </Grid>
            {/* bread crumb */}
            <Grid item>
              <BreadCrumb data={breadCrumb ?? []} />
            </Grid>
            {Boolean(orderInfo?.tracking_info?.consignmentId) &&
              pathname.includes("/order/") && (
                <Grid className="flex items-center pl-2" item>
                  <CustomText
                    className="underline cursor-pointer"
                    color="secondary"
                    bold
                    onClick={handleClickConsignment}
                  >
                    {orderInfo?.tracking_info?.consignmentId ?? ""}
                  </CustomText>
                </Grid>
              )}
          </Grid>
        </Grid>
        {/* search box */}
        {/* <Grid item>
          <SearchBox />
        </Grid> */}
      </Grid>
      <iframe
        title="delivery ticket"
        style={{ display: "none" }}
        id="printf"
        src={file}
        name="printf"
      ></iframe>
    </AppBar>
  );
}
